import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import EditBlueIcon from "../Assets/svgs/EditBlueIcon";
import { Loader } from "../Common/Loader";
import { assistantNameValidation, nameValidation } from "../Common/Validations";
import { ErrorModel } from "../Model/ErrorModel";
import { updateAssistantImage } from "../Redux/Slice/Assistant/UpdateAssistantImageSlice";

const EditAssistantModal = ({ selectedBot, closePopup, onSuccess }) => {
  const dispatch = useDispatch();
  const [asstImage, setAsstImage] = useState();
  const [asstImageUrl, setAsstImageUrl] = useState();
  const [asstName, setAsstName] = useState("");
  const [errorMessage, setErrorMessage] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [showErrorPopUp, setShowErrorPopup] = useState(false);
  const [nameError, setNameError] = useState("");
  const [hasChanged, setHasChanged] = useState(false);

  const handleChange = async (e) => {
    if (e?.target?.files && e?.target?.files && e.target.files?.length) {
      setHasChanged(true);
      setAsstImage(e.target.files[0]);
      setAsstImageUrl(URL.createObjectURL(e.target.files[0]));
    }
  };

  useEffect(() => {
    if (selectedBot?.name) {
      setAsstName(selectedBot?.name);
    }
  }, [selectedBot]);

  const handelNameChange = (e) => {
    let value = e?.target?.value;
    const isValid = assistantNameValidation(value);
    if (isValid || value.trim() === "") {
      setNameError("");
    } else {
      setNameError("Please enter valid Assistant name");
    }
    let capitalized = value.charAt(0).toString().toUpperCase();
    value = capitalized + value.substring(1);
    setHasChanged(true);
    setAsstName(value);
  };

  const handleSubmit = async () => {
    const formData = new FormData();
    if (asstImage) {
      formData.append("file", asstImage);
    }
    formData.append("name", asstName);

    setIsLoading(true);
    const result = await dispatch(
      updateAssistantImage({ id: selectedBot?.id, body: formData })
    );
    if (
      updateAssistantImage.fulfilled.match(result) &&
      result?.payload?.success === true
    ) {
      setIsLoading(false);
      onSuccess("Assistant Updated Successfully!");
    } else {
      setIsLoading(false);
      setShowErrorPopup(true);
      setErrorMessage(result?.payload?.error?.message);
      setTimeout(() => {
        setShowErrorPopup(false);
      }, 1500);
    }
  };

  return (
    <>
      {isLoading ? (
        <Loader />
      ) : showErrorPopUp ? (
        <ErrorModel message={errorMessage} />
      ) : (
        <div className="modal modal--createAssistant modal--open">
          <div className="modal__dialog">
            <div className="modal__content modal__content--lg">
              <div className="modal__header">
                <h1 className="modal__header--title">Update Assistant</h1>
                <p className="para">Update your Assistant details below.</p>
                <button
                  className="btn btn__transparent btnClose"
                  onClick={() => closePopup()}
                >
                  <svg
                    width="25"
                    height="24"
                    viewBox="0 0 25 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <rect
                      x="0.586914"
                      width="24"
                      height="24"
                      rx="12"
                      fill="#E5E5E5"
                    />
                    <path
                      d="M12.5869 10.8891L16.476 7L17.5869 8.11094L13.6979 12L17.5869 15.8891L16.476 17L12.5869 13.1109L8.69785 17L7.58691 15.8891L11.476 12L7.58691 8.11094L8.69785 7L12.5869 10.8891Z"
                      fill="#4F4F4F"
                    />
                  </svg>
                </button>
              </div>
              <div className="modal__body modal-body-left">
                <div className="createAssistant createAssistant--voicebot">
                  <div className="createAssistant__list">
                    <div className="createAssistant__item">
                      <label
                        className="createAssistant__card"
                        style={{ borderWidth: 0 }}
                      >
                        {!asstImage && !selectedBot?.avatar ? (
                          <svg
                            width="41"
                            height="41"
                            viewBox="0 0 41 41"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M20.5 3V38M3 20.5H38"
                              stroke="#1C1C1C"
                              stroke-opacity="0.28"
                              stroke-width="5"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                            />
                          </svg>
                        ) : null}
                        {asstImageUrl ? (
                          <img src={asstImageUrl} />
                        ) : selectedBot?.avatar ? (
                          <img src={selectedBot?.avatar} />
                        ) : null}
                      </label>
                      <label className="backBtn" style={{ cursor: "pointer" }}>
                        <EditBlueIcon />
                        Change Picture
                        <input
                          id="uploadFile"
                          className="form__input"
                          type="file"
                          name="image"
                          style={{
                            display: "none",
                            padding: 0,
                            border: 0,
                            flex: "1 1 auto",
                            height: "auto",
                            borderRadius: 0,
                          }}
                          onChange={handleChange}
                          accept="image/*"
                        />
                      </label>
                    </div>
                  </div>
                  <div className="formRow">
                    <div className="formCol">
                      <div className="form__Field">
                        <label for="voicebotName" className="form__label">
                          Assistant Name
                        </label>
                        <input
                          type="text"
                          id="voicebotName"
                          value={asstName}
                          maxLength={40}
                          onChange={handelNameChange}
                          name="voicebotName"
                          className="form__input form__input--sm"
                          placeholder="Assistant name"
                          spellcheck="false"
                        />
                      </div>
                      <div className="form__error">{nameError}</div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="modal__footer">
                <div className="btn__group">
                  <button
                    className="btn btn__white"
                    onClick={() => closePopup()}
                  >
                    Cancel
                  </button>
                  <button
                    className="btn btn__primary"
                    disabled={
                      asstName.trim() === "" || nameError != "" || !hasChanged
                    }
                    onClick={handleSubmit}
                  >
                    Update Assistant
                  </button>
                </div>
              </div>
            </div>
          </div>
          <div className="modal__backdrop"></div>
        </div>
      )}
    </>
  );
};

export default EditAssistantModal;
